import { connect } from 'react-redux'
import LegislationTiledMenu from 'components/tiled-menu/LegislationTiledMenu'
import { setLegislationSelectedAols } from 'redux/actions'

const mapStateToProps = (state, ownProps) => ({
  folders: ownProps.folders || state.legislation.folders,
  showFavouritesOnly: state.legislation.showFavouritesOnly,
  keyword: state.legislation.keyword,
  selectedAols: state.legislation.selectedAols
})

const mapDispatchToProps = dispatch => ({
  setSelectedAols: selectedAols => dispatch(setLegislationSelectedAols(selectedAols))
})

export default connect(mapStateToProps, mapDispatchToProps)(LegislationTiledMenu)
